import useTemplatesViewModel from './TemplatesViewModel'

import CircleSpinner from '@components/shared/CircleSpinner'
import MiniUploadWidget from '@components/shared/MiniUploadWidget'
import ConfirmationModal from '@components/shared/ConfirmationModal'
import { Link } from 'react-router-dom'
import { FaTrash } from 'react-icons/fa'

const Templates = () => {
    
    const {
        loading,
        loadingCreateTemplate,
        exportTemplates,
        newTemplateType,
        setNewTemplateType,
        newTemplateName,
        setNewTemplateName,
        newTemplateFile,
        setNewTemplateFile,
        pendingDeleteTemplate,
        setPendingDeleteTemplate,
        
        templateName,
        
        onCreateTemplateClick,
        onConfirmDeleteTemplateClick,
    } = useTemplatesViewModel()
    
    if (loading && !exportTemplates?.length) return (
        <CircleSpinner className="flex justify-center p-5 my-5" />
    )
    
    return (
        
        <div className="Templates">
            
            <h3 className="text-xl">Create New Export Runsheet Template</h3>
            
            <div className="flex items-center content-center justify-between mt-2 form-group">
                <input
                    className="w-full input input-bordered grow"
                    type="text"
                    value={newTemplateName}
                    placeholder={templateName}
                    autoComplete="off"
                    disabled={loadingCreateTemplate}
                    onChange={e => setNewTemplateName(e.target.value)} />
                <select
                    className="w-auto pr-4 ml-3 select grow"
                    value={newTemplateType}
                    disabled={loadingCreateTemplate || true}
                    title="Only Excel supported currently"
                    onChange={e => setNewTemplateType(e.target.value)}>
                    <option value="excel">
                        Excel
                    </option>
                </select>
                <MiniUploadWidget
                    className="ml-3 grow"
                    file={newTemplateFile}
                    disabled={loadingCreateTemplate}
                    setFile={setNewTemplateFile} />
                <button
                    className="ml-3 btn btn-primary"
                    disabled={loadingCreateTemplate}
                    onClick={onCreateTemplateClick}>
                    {loadingCreateTemplate
                        ? <CircleSpinner className="px-4 mt-1" size="16px" />
                        : 'Create Export Template'}
                </button>
            </div>
            
            {!exportTemplates.length && (
                <div className="card">
                    <div className="card-body">
                        <p>No export templates yet.</p>
                    </div>
                </div>
            )}
            
            <table className="w-full table-auto mt-3">
                <thead>
                    <tr>
                        <th>Organization</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>{/* Actions */}</th>
                    </tr>
                </thead>
                <tbody>
                    {exportTemplates?.map(it => (
                        <tr key={`template-${it.id}`}>
                            <td>{it?.organization?.name ?? 'Parse'}</td>
                            <td>
                                <Link
                                    className=""
                                    to={it.id}>
                                    {it.name}
                                </Link>
                            </td>
                            <td>{it.type}</td>
                            <td>
                                <div className="flex items-center content-center justify-end">
                                    {it.createdById !== null && it.organizationId !== null && (
                                        <button
                                            className="w-auto text-red-800 btn btn-link hover:text-red-500"
                                            title="Remove Member"
                                            onClick={() => setPendingDeleteTemplate(it)}>
                                            <FaTrash />
                                        </button>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            
            <ConfirmationModal
                showModal={Boolean(pendingDeleteTemplate)}
                showHideModal={setPendingDeleteTemplate}
                title="Delete Export Runsheet Template"
                message={`Are you sure you want to delete the export template "${pendingDeleteTemplate?.name}"`}
                onConfirm={onConfirmDeleteTemplateClick} />
        
        </div>
        
    )
    
}

export default Templates
